import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface OrderItem {
  id: string
  orderId: string
  unitPrice: number
  quantity: number
  subtotal: number
  itemStatus: number
  itemStatusDesc: string | null
  itemTime: string
  writeOffTime: string | null
}

export interface OrderInfo {
  id: number
  orderNo: string
  orderType: string
  orderStatus: number
  orderStatusDesc: string
  userId: number
  userName: string
  userNickname: string
  userTel: string
  totalQuantity: number
  orderAmount: number
  payAmount: number
  payTypeDesc: string
  payType: string
  transactionId: string
  createTime: string
  payTime: string
  expireTime: string
  cancelTime: string
  remark: string
  items: OrderItem[]
}

export interface OrderListItem {
  id: number
  orderNo: string
  orderType: string
  productId: number
  productType: string
  productName: string
  productImg: string
  exhibitionAddress: string
  sessionId: number
  sessionDate: string
  timeSlotCode: string
  timeSlotName: string
  sessionTime: string
  sessionDesc: string
  totalQuantity: number
  userId: number
  userName: string
  payAmount: number
  orderStatus: number
  orderStatusDesc: string
  createTime: string
  expireTime: string
}

export const useOrder = defineStore('order', {
  state: () => ({}),
  actions: {
    // 分页查询订单
    async getOrderPage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/order/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 查询订单详情
    async getOrderDetail(orderId: number | string) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/order/detail/${orderId}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
